import React, { createContext, useContext, useState, useEffect } from "react";
import brandingAPI from "../services/api/brandingAPI";
import { imageURL } from "../services/api/config";
const BrandingContext = createContext();

export const BrandingProvider = ({ children }) => {
    const [brandName, setBrandName] = useState("");
    const [isUpdating, setIsUpdating] = useState(false);
    const [id, setId] = useState();
    const [existingLogo, setExistingLogo] = useState("");
    const [onlinePayment, setOnlinePayment] = useState(false);
    const [connectedAccountId, setConnectedAccountId] = useState("");

    useEffect(() => {
        fetchBranding();
    }, []);


    const fetchBranding = async () => {
        try {
            const data = await brandingAPI.GetBranding();
            if (data.resultData) {
                setBrandName(data.resultData.name);
                setOnlinePayment(data.resultData.onlinePayment || "");
                setIsUpdating(true);
                setId(data.resultData.id);
                setConnectedAccountId(data.resultData.connectedAccountId || "");

                if (data.resultData.logo) {
                    setExistingLogo(`${imageURL}${data.resultData.logo}`);
                }
            }
        } catch (error) {
            console.error("Error fetching branding:", error);
        }
    };


    return (
        <BrandingContext.Provider
            value={{
                id,
                brandName,
                existingLogo,
                isUpdating,
                onlinePayment,
                connectedAccountId,
            }}
        >
            {children}
        </BrandingContext.Provider>
    );
};

export const useBranding = () => {
    return useContext(BrandingContext);
};
